export const isFormCompleted = (extrasRef, totalEnvios) => {
  let fieldsNotCompleted = true;

  const CMInputs = extrasRef.CMinputRefs.current.filter(
    (input) => input !== null
  );

  if (CMInputs.length > 0 && CMInputs !== null) {
    CMInputs.forEach((input) => {
      if (input.value === "") {
        fieldsNotCompleted = false;
      }
    });
  }

  const EEInputs = extrasRef.EEinputRefs.current.filter(
    (input) => input !== null
  );

  if (EEInputs.length > 0 && EEInputs !== null) {
    EEInputs.forEach((input) => {
      if (input.value === "") {
        fieldsNotCompleted = false;
      }
    });
  }

  const ECInputs = extrasRef.ECinputRefs.current.filter(
    (input) => Object.keys(input).length !== 0
  );

  ECInputs.slice(0, totalEnvios).forEach((refObject) => {
    Object.values(refObject)
      .filter((input) => input !== null)
      .forEach((input) => {
        if (input.value === "") {
          fieldsNotCompleted = false;
        }
      });
  });
  return fieldsNotCompleted;
};
